module.exports = __webpack_public_path__ + "img/add-term.ce20eae3.svg";